const bookList = [
  {
    name: 'No One is Too Small to Make a Difference',
    author: 'Greta Thunberg',
    description: 'A collection of climate activist Greta Thunberg\'s powerful speeches, this book asks decision-makers to wake up and take action to protect our planet.',
    imageCover: 'greta-thunberg-book',
  },
  {
    name: 'Start With Why: How Great Leaders Inspire Everyone to Take Action',
    author: 'Simon Sinek',
    description: 'Simon Sinek outlines why businesses who are guided by \'why\' they do things rather than only \'what\' they do are more likely to succeed and thrive. ',
    imageCover: 'simon-sinek-book',
  },
  {
    name: 'The Tree: A Natural History of What Trees Are, How They Live, and Why They Matter',
    author: 'Colin Tudge',
    description: 'Colin Tudge travels around the world, bringing to life stories and facts about the trees around us.',
    imageCover: 'tree-book',
  },
  {
    name: 'Team Human',
    author: 'Douglas Rushkoff',
    description: 'Outlining how we can achieve our greatest aspirations when we work together, Team Human reminds us of the power of human connections',
    imageCover: 'team-human-book',
  },
  {
    name: 'Mindset',
    author: 'Carol Dweck',
    description: 'Our success is not shaped only by our talents or natural ability, but by our mindset. Personally or professionally, we have the power to make change happen.',
    imageCover: 'mindset-book',
  },
  {
    name: 'Play Bigger',
    author: 'Al Ramadan, Christopher Lochhead, Dave Peterson, Kevin Maney',
    description: 'Don\'t beat the competition at the old game &ndash; invent a new one. Play Bigger details how category design leads to new ways of thinking and doing business.',
    imageCover: 'play-bigger-book',
  },
  {
    name: 'Customer Loyalty:<br> How to Earn It,<br> How to Keep It',
    author: 'Jill Griffin',
    description: 'Jill Griffin examines what it takes to go beyond customer satisfaction and build real, lasting customer loyalty.',
    imageCover: 'customer-loyalty-book',
  },
  {
    name: 'Chief Customer Officer',
    author: 'Jeanne Bliss',
    description: 'Jeanne Bliss provides a framework to advance customer experience and transform your business by genuinely helping your customers. ',
    imageCover: 'jeanne-bliss-chief-book',
  },
  {
    name: 'Start Something That Matters',
    author: 'Blake Mycoskie',
    description: 'An inspiring story of how people can use their entrepreneurial spirit to make a real difference in the world. ',
    imageCover: 'blake-mycoskie-book',
  },
  {
    name: 'Collaborative Intelligence: Thinking with People Who Think Differently',
    author: 'Dawna Markova and Angie McArthur',
    description: 'Collaborative Intelligence teaches us how to improve our ability to think with others on behalf of what matters to us all.',
    imageCover: 'collaborative-intelligence',
  },
  {
    name: 'The Compound Effect',
    author: 'Darren Hardy',
    description: 'Little decisions we make every day can have a big impact on our lives and success. This book shows how small actions can reap major rewards.',
    imageCover: 'compound-effect-book',
  },
  {
    name: 'Change Masters',
    author: 'Rosabeth Moss Kanter',
    description: 'This book looks at some of the most prominent companies in America and how their structures, culture and strategies have led to productive change.',
    imageCover: 'change-masters-book',
  },
  {
    name: 'Do the KIND Thing',
    author: 'Daniel Lubetzky',
    description: 'A handbook for living and working with compassion, this book outlines why putting kindness first leads to success. ',
    imageCover: 'daniel-lubetzky-book',
  },
  {
    name: 'Educated',
    author: 'Tara Westover',
    description: 'Westover\'s courage and determination shines through in her powerful story of the transformative nature of education. ',
    imageCover: 'tara-westover-book',
  },
];

const bookCard = document.querySelector('.js-book');

function loadBook() {
  const selectedBook = bookList[Math.floor(Math.random() * bookList.length)];
  const bookCardInner = `<img src="/assets/dest/images/desktop/other/${selectedBook.imageCover}.png" alt="${selectedBook.name}">
    <figcaption class="js-book">
      <h4>${selectedBook.name}</h4>
      <span>${selectedBook.author}</span>
      <p class="sm-text">${selectedBook.description}</p>
    </figcaption>`;
  bookCard.innerHTML = bookCardInner;
}

if (bookCard) loadBook();
